export const nameSpace = '@@/plan-builder';
